var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoodPack5 = function SvgGoodPack5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#good-pack5_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#good-pack5_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.826,
    cy: 195.666,
    rx: 69.139,
    ry: 24.259,
    fill: "#FEAE52"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.01 134.398c0 48.159-41.739 87.334-93.399 87.334-51.66 0-93.398-39.175-93.398-87.334 0-48.159 41.739-87.334 93.398-87.334 51.66 0 93.399 39.175 93.399 87.334Z",
    fill: "#FED052",
    stroke: "url(#good-pack5_svg__c)",
    strokeWidth: 2.426
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.611,
    cy: 134.398,
    rx: 94.611,
    ry: 88.547,
    fill: "url(#good-pack5_svg__d)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.395,
    cy: 77.389,
    rx: 64.287,
    ry: 36.389,
    fill: "url(#good-pack5_svg__e)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#good-pack5_svg__f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.453,
    cy: 144.103,
    rx: 32.75,
    ry: 18.195,
    fill: "url(#good-pack5_svg__g)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#good-pack5_svg__h)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.345,
    cy: 144.103,
    rx: 32.75,
    ry: 18.195,
    fill: "url(#good-pack5_svg__i)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.484 155.11c-21.246 9.912-42.932 5.021-54.248-.04-1.699-.759-3.704.435-3.606 2.293.931 17.65 7.843 46.331 30.308 46.331 22.455 0 29.864-28.657 31.103-46.309.131-1.861-1.866-3.064-3.557-2.275Z",
    fill: "url(#good-pack5_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.008 190.943c-16.487-12.468-35.493-5.195-42.076 0 1.717 4.25 8.93 12.751 20.609 12.751 11.678 0 19.463-8.501 21.467-12.751Z",
    fill: "url(#good-pack5_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.484 155.11c-21.246 9.912-42.932 5.021-54.248-.04-1.699-.759-3.704.435-3.606 2.293.931 17.65 7.843 46.331 30.308 46.331 22.455 0 29.864-28.657 31.103-46.309.131-1.861-1.866-3.064-3.557-2.275Z",
    stroke: "url(#good-pack5_svg__l)",
    strokeWidth: 2.426
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.755 110.79c0 18.11-13.582 32.708-30.239 32.708-16.656 0-30.239-14.598-30.239-32.708 0-18.109 13.583-32.707 30.239-32.707 16.657 0 30.239 14.598 30.239 32.707Z",
    fill: "url(#good-pack5_svg__m)",
    stroke: "url(#good-pack5_svg__n)",
    strokeWidth: 1.234
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.389,
    cy: 116.961,
    rx: 13.577,
    ry: 14.811,
    fill: "url(#good-pack5_svg__o)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.75,
    cy: 107.088,
    r: 7.405,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.431 115.727c0 13.171 9.878 23.787 21.992 23.787s21.991-10.616 21.991-23.787c0-13.17-9.877-23.787-21.991-23.787-12.114 0-21.992 10.617-21.992 23.787Z",
    fill: "url(#good-pack5_svg__p)",
    stroke: "url(#good-pack5_svg__q)",
    strokeWidth: 0.898
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.874,
    cy: 10.771,
    rx: 9.874,
    ry: 10.771,
    transform: "matrix(-1 0 0 1 165.115 109.444)",
    fill: "url(#good-pack5_svg__r)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.386,
    cy: 5.386,
    r: 5.386,
    transform: "matrix(-1 0 0 1 153.558 108.322)",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "good-pack5_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 36.389 -64.2872 0 132.395 77.389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#FCF2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF2BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "good-pack5_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.21296 14.55565 -26.20009 2.18332 81.453 144.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B0A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0B0A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "good-pack5_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.21296 14.55565 -26.20009 2.18332 183.345 144.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B0A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0B0A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "good-pack5_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 25.2457 -30.8558 0 134.372 178.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "good-pack5_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 33.3243 -30.8558 0 103.516 110.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "good-pack5_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 14.8108 -13.5766 0 113.389 116.961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "good-pack5_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 24.2358 -22.4406 0 162.423 115.727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "good-pack5_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 10.7715 -9.87386 0 9.874 10.771)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "good-pack5_svg__c",
    x1: 39,
    y1: 141.676,
    x2: 228.223,
    y2: 140.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D39D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#FDCA4D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D39D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "good-pack5_svg__d",
    x1: 133.611,
    y1: 187.768,
    x2: 133.611,
    y2: 222.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2BD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "good-pack5_svg__k",
    x1: 133.399,
    y1: 183.859,
    x2: 133.399,
    y2: 202.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FF351F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "good-pack5_svg__l",
    x1: 133.069,
    y1: 102.712,
    x2: 125.908,
    y2: 204.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "good-pack5_svg__n",
    x1: 103.516,
    y1: 77.466,
    x2: 103.516,
    y2: 144.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC03F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE684"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "good-pack5_svg__q",
    x1: 162.423,
    y1: 91.491,
    x2: 162.423,
    y2: 139.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC03F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE684"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "good-pack5_svg__b",
    x: 12.073,
    y: 117.794,
    width: 245.505,
    height: 155.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.807,
    result: "effect1_foregroundBlur_747_141"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "good-pack5_svg__f",
    x: 33.419,
    y: 110.625,
    width: 96.067,
    height: 66.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.642,
    result: "effect1_foregroundBlur_747_141"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "good-pack5_svg__h",
    x: 135.311,
    y: 110.625,
    width: 96.067,
    height: 66.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.642,
    result: "effect1_foregroundBlur_747_141"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "good-pack5_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h270v270H0z"
  })))));
};
export default SvgGoodPack5;